import { render, staticRenderFns } from "./OverviewSaleList.vue?vue&type=template&id=582bf6f6&scoped=true"
import script from "./OverviewSaleList.vue?vue&type=script&lang=js"
export * from "./OverviewSaleList.vue?vue&type=script&lang=js"
import style0 from "./OverviewSaleList.vue?vue&type=style&index=0&id=582bf6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582bf6f6",
  null
  
)

export default component.exports